export default __webpack_public_path__ + "static/media/atpcare-origin.d4b35779.png";